import { loadStripe } from '@stripe/stripe-js'

export const STRIPE_PUBLISHABLE_KEY =
  process.env.STRIPE_PUBLISHABLE_KEY ||
  'pk_test_51T9pdRLmWectnEtrxFheSsBTXHZUqQZlD9BYFqCnrhrXNiLKTpp0K3eSGxrS2EwesqtVjsIEJbOXKCHjbkM7GfD100POs3T5Zm'

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)
